/**
 * 特陈竞价接口
 */
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const specialbidding = {
    
    // 商品大类接口
    getGoodsClass (params) {
        return axios.post('/commoditymanagement/itemDept/itemDeptList',qs.stringify(params));
    },

    // 获取资源列表
    getResourceList: (data)=>{
       return axios.post('/special-display/displayRes/page', data)
    },

    // 获取门店省份列表
    getStoreProvinceList: (data) => {
        return axios.post('/institutionmanager/store/getAllProvinceList',  qs.stringify(data))
    },
    // 获取门店城市列表
    getStoreCityList: (data) => {
        return axios.post('/institutionmanager/store/getAllCityList',  qs.stringify(data))
    },

    // 获取门店列表
    getStoreList: (data) => {
        return axios.post('/institutionmanager/store/getStoreList', qs.stringify(data))
    },

    // 获取特陈抢购列表
    getSuppSpeciaTenderDate: (data) => {
        return axios.post('/specialtender/specialTender/getSuppSpeciaTenderDate', data)
    },

    // 点击竞拍查询当条抢购信息
    getAuctionAmount: (data) => {
        return axios.post('/specialtender/specialTender/getAuctionAmount', data)
    },

    // 点击竞拍确定
    suppAuction: (data) => {
        return axios.post('/specialtender/specialTender/suppAuction', data)
    },

    // 点击立即购买
    suppLimitedTime: (data) => {
        return axios.post('/specialtender/specialTender/suppLimitedTime', data)
    },

    // 获取购买记录列表
    getSpecialTenderInformation: (data) => {
        return axios.post('/specialtender/specialTender/getSpecialTenderInformation', data)
    },
    
    /**
     * 下载文件接口
     * @param  {[type]} url [接口请求地址]
     */
    download: (url)=>{
        return axios({
          method: 'get',
          url: url,
          // data: qs.stringify(params),
          timeout: 1000 * 60 * 2,
          responseType: 'blob'
        });
    },
    //供应商id -- 导出购买记录
    exportSpecialTenderInformation(params){
        return axios({
            method: 'post',
            url: '/specialtender/specialTender/exportSpecialTenderInformation',
            data: params,
            timeout: 1000 * 60 * 2,
            responseType: 'blob'
        });
    },
    
}

export default specialbidding;



// WEBPACK FOOTER //
// ./src/api/api_specialbidding.js